<template>
    <div class="main">
        <div class="home">
            <div style="padding: 10px 50px">
                <el-form>
                    <el-row>
                        <el-col class="title-text">
                            <p>{{form.title}}</p>
                        </el-col>
                    </el-row>
                    <el-row class="detail-time" :gutter="16">
                        <el-col class="title time" :span="12">
                            <div>发布时间：{{form.publishTime | formatDate}}</div>
                        </el-col>
                        <el-col class="title time" :span="12">
                            <div>来源：{{form.source}}</div>
                        </el-col>
                    </el-row>
                    <el-row class="textPre" v-html="form.rdContent" style="text-align: left;"></el-row>
                    <el-row class="doorFujian"><span>{{tableData.length > 0 ? '附件:' : ''}}</span></el-row>
                    <el-row v-for="(item,index) in tableData" :key="index" class="fujianContent">
                        <el-col :span="20" class="fujianInner"><a :href='urlActionDraw+"?attachmentId="+item.id' class="fujianA">
                            <i class="el-icon-paperclip"></i>&nbsp&nbsp{{item.fileName}}.{{item.fileExt}}</a>
                        </el-col>
                    </el-row>
                    <el-row>
                        <div class="footer">
                            <el-button type="info" @click="route_goFun12('热点信息')"
                                       style="font-size: 14px;margin-bottom: 10px">返回
                            </el-button>
                        </div>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from "@/utils/format"

    export default {
        data() {
            return {
                tableData: [],
                urlActionDraw: window.SITE_CONFIG['baseUrl'] + '/file/downloadFile',
                form: {
                    applicationNo: '',
                    createTime: '',
                    creatorId: '',
                    delFlag: '',
                    id: '',
                    rdContent: '',
                    registerTime: '',
                    registerTimeStr: '',
                    sort: '',
                    source: '',
                    status: '',
                    title: '',
                    updateTime: '',
                    updateUserId: '',
                    pageSize: 5,
                    content: '',
                },
                pagination: {
                    count: 0,   //总页数
                    pageSize: 5,  //每页限制
                    pages: 0,
                    pageNum: 1,  //当前页
                    list: []
                },


            }
        },
        filters: {
            formatDate(time) {
                var data = new Date(time);
                return formatDate(data, 'yyyy-MM-dd');
            }
        },
        created() {
            this.getIdSelect()
            this.getFileMetaData()
        },
        watch: {
            '$route': "getIdSelect"
        },
        methods: {
            getIdSelect() {
                const textContentId = this.$route.query.id4
                this.id = textContentId
                this.$axios({url: '/rdApplication/queryById', method: 'get', params: {id: this.id}}).then(({data}) => {
                    const that = this
                    that.form = data.result
                })
            },

            getFileMetaData() {
                const textContentId = this.$route.query.id4
                this.id = textContentId
                var fileData = {
                    tableUuid: this.id,
                    tableName: 'rdApplicationForm',
                    tableKey: 'rdAttachment',
                }
                this.$axios({url: '/file/getFileMetaData', method: 'post', data: fileData}).then(({data}) => {
                    this.tableData = data.result
                })
            },

            //每页下拉显示数据
            handleSizeChange: function (size) {
                this.pagination.pageSize = size;
                this.PageSelect();
            },
            //点击第几页
            handleCurrentChange: function (pageNum) {
                this.pagination.pageNum = pageNum;
                this.PageSelect();
            },

            route_goFun12(name) {
                this.$router.push({
                    path: '/zwgk-door',
                    query: {
                        name: name,
                        id: 9
                    }
                })
            },


        }
    }
</script>

<style>
    .text {
        text-align: center;
        width: 60%;
        margin: 20px auto 0px;
    }

    .text .textPre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        *word-wrap: break-word;
        *white-space: normal;
        text-align: left;
        font-size: 16px;
        color: #353E4B;
    }

    .title-text {
        font-family: "Arial Normal", "Arial";
        font-weight: 400;
        font-size: 24px;
        word-break: break-all;
        word-wrap: break-word;
        border-bottom: 2px solid #bababa;
        line-height: 60px;
        color: #4E4E4E;
    }

    .detail-time {
        margin-bottom: 32px;
        margin-top: 14px;
    }

    .title {
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: center;
    }

    .time {
        color: #5E6D82;
        font-size: 14px;
    }

</style>
